import React from 'react'
import coreCoordinatorData from './coreCoordinatorData';
import { Box } from '@chakra-ui/react';
import Card2 from "./Card2";


const Organizers = () => {
    return (
        <Box minW={'350px'} direction='row' wrap='wrap' align='center' justify='center'>
            {coreCoordinatorData.map((user, index) =>
              <Card2 user={user} key={index} />
            )}
          </Box>
        // <div className='organizers'>
        //     <div className='container'>
        //         <div className='card1'>
        //             <div className='avatar'>
        //             </div>
        //             <div className='name'>
        //                 Kanishak chaurasia
        //             </div>
        //             <div className='contact'>
        //                 +91 9312442192
        //             </div>
        //         </div>
        //         <div className='card1'>
        //             <div className='avatar'>
        //             </div>
        //             <div className='name'>
        //                 Pranav vashistha
        //             </div>
        //             <div className='contact'>
        //                 +91 9548577787
        //             </div>
        //         </div>
        //         <div className='card1'>
        //             <div className='avatar'>
        //             </div>
        //             <div className='name'>
        //                 Vardhan Bhardwaj
        //             </div>
        //             <div className='contact'>
        //                 +91 9871844065
        //             </div>
        //         </div>
        //         <div className='card1'>
        //             <div className='avatar'>
        //             </div>
        //             <div className='name'>
        //                 Ujjawal Chaudhary
        //             </div>
        //             <div className='contact'>
        //                 +91 9990009342
        //             </div>
        //         </div>
        //         <div className='card1'>
        //             <div className='avatar'>
        //             </div>
        //             <div className='name'>
        //                 Shivam Kumar
        //             </div>
        //             <div className='contact'>
        //                 +91 6206349188
        //             </div>
        //         </div>
        //     </div>
        // </div>
    )
}

export default Organizers